import { useState, useCallback } from 'react'
import dayjs from 'dayjs'
import { AccordionSection } from './useAccordionState'
import { getDefaultDateRange } from '../lib/dateHelpers'

export const useDateManagement = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  const [selectedRange, setSelectedRange] = useState<[Date, Date]>(getDefaultDateRange)

  const handleDateChange = useCallback(
    (expandedSection: AccordionSection | false, onDailyRefresh: () => void) => 
      (date: dayjs.Dayjs | null) => {
        if (date) {
          setSelectedDate(date.toDate())
          if (expandedSection === 'daily') {
            onDailyRefresh()
          }
        }
      },
    []
  )

  const handleRangeChange = useCallback(
    (expandedSection: AccordionSection | false, onWeeklyRefresh: () => void, onDurationRefresh: () => void) => 
      ({ start, end }: { start: Date | null; end: Date | null }) => {
        if (start && end) {
          setSelectedRange([start, end])
          if (expandedSection === 'weekly' || expandedSection === 'duration') {
            if (expandedSection === 'weekly') onWeeklyRefresh()
            if (expandedSection === 'duration') onDurationRefresh()
          }
        }
      },
    []
  )

  return {
    selectedDate,
    selectedRange,
    setSelectedDate,
    setSelectedRange,
    handleDateChange,
    handleRangeChange,
  }
}
